import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EMPTY_STATE_IMAGE } from '@app/infrastructure/state-switcher/state-switcher.config';

@Component({
	selector: 'app-default-empty-state',
	templateUrl: './default-empty-state.component.html',
	styleUrls: ['./default-empty-state.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultEmptyStateComponent {
	@Input() public image = EMPTY_STATE_IMAGE.noResults;
	@Input() public title = 'No data available';
	@Input() public subTitle = 'No data to show you right now';

	public isShowContent = false;

	public onImageLoaded(): void {
		this.isShowContent = true;
	}
}
